/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:c589d029-60bb-4d07-b162-4fd21bdd4df1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_MsuJkZrOi",
    "aws_user_pools_web_client_id": "75vof0hehcba6brukl2e9hgh84",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "goatchat221428-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
